module.exports = __webpack_public_path__ + "static/media/bl.4d724b8e.svg";